export const constants = {
  recentSearchesMaxCount: 10,
}
